import { render, staticRenderFns } from "./CalendarWeek.vue?vue&type=template&id=6975656a&"
import script from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js&"
export * from "./CalendarWeek.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6975656a')) {
      api.createRecord('6975656a', component.options)
    } else {
      api.reload('6975656a', component.options)
    }
    module.hot.accept("./CalendarWeek.vue?vue&type=template&id=6975656a&", function () {
      api.rerender('6975656a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/DatePicker/components/CalendarWeek.vue"
export default component.exports